import PropTypes from 'prop-types';
import React from 'react';

import './Icon.scss';

export default class Icon extends React.PureComponent {
    static propTypes = {
        /**
         * Name of the icon: eg: "facebook", "instagram", ect
         */
        name: PropTypes.string.isRequired,
        /**
         * Background color of the icon: current supporting "primary-bg" and "black-bg"
         */
        bgColor: PropTypes.string,
        size: PropTypes.string,
    };

    static defaultProps = {
        bgColor: 'primary-bg',
        size: '',
    };

    render() {
        return (
            <div className={`component-Elements-Icon ${this.props.size}`}>
                <div
                    className={`icon ${this.props.name} ${this.props.bgColor}`}
                />
            </div>
        );
    }
}
